import { type ReactElement } from "react";

import { type FeatureFlagNamesEnum } from "src/graphql/generated/types";
import { useHasFeatureFlagActivated } from "src/hooks";

interface Props {
  feature: FeatureFlagNamesEnum;
  children: ReactElement;
}

export const FeatureFlag = ({ feature, children }: Props) => {
  if (!useHasFeatureFlagActivated(feature)) {return null;}

  return children;
};
